import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box, Collapse, Typography } from "@mui/material";
import { useState } from "react";
import { useSingleNivel } from "../../../../context/SuperAdmin/OASContexts/SingleNivelContext";

const CurrentAsignsDropdown = () => {
  const [open, setOpen] = useState(false);
  const { nivelAsigns } = useSingleNivel();

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Box
      sx={{
        width: "100%",
        border: "1px solid rgba(51, 107, 135, 0.5)", // Borde con opacidad
        borderRadius: "8px", // Bordes redondeados
        padding: "8px 16px", // Padding general
        transition: "all 0.3s ease", // Suaviza la transición
      }}
    >
      {/* Botón de encabezado */}
      <Box
        onClick={handleToggle}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          width: "100%", // Ancho completo
        }}
      >
        <Typography variant="h6" component="h2" color="#000">
          Asignaturas agregadas{" "}
          <Typography component="span" color={"#73767E"} fontSize={"20px"}>
            ({nivelAsigns.length})
          </Typography>
        </Typography>
        <ArrowDropDownIcon
          sx={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)", // Rotar cuando está abierto
            transition: "0.3s",
          }}
        />
      </Box>

      {/* Contenido que se expande dentro del mismo contenedor */}
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box
          sx={{
            marginTop: "8px",
            paddingTop: "8px",
            borderTop: "1px solid rgba(51, 107, 135, 0.5)", // Separador sutil
            maxHeight: "350px", // Máximo de altura
            overflowY: "auto", // Scroll vertical si es necesario
          }}
        >
          {nivelAsigns.length > 0 ? (
            nivelAsigns.map((asign, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  color: "#000",
                  fontFamily: "Montserrat",
                  padding: "4px 0",
                }}
              >
                <Typography>• {asign.asignatura}</Typography>
              </Box>
            ))
          ) : (
            <Typography color="#73767E" fontStyle="italic" textAlign="center">
              No hay asignaturas agregadas aún
            </Typography>
          )}
        </Box>
      </Collapse>
    </Box>
  );
};

export default CurrentAsignsDropdown;
